import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'

export const sentSmsTableId = 'sentSmsTable' as RegisteredServices
export const bulkSentSmsDeliveredTableId = 'bulkSentSmsDeliveredTable' as RegisteredServices
export const bulkSentSmsSentTableId = 'bulkSentSmsSentTable' as RegisteredServices
export const bulkSentSmsFailedTableId = 'bulkSentSmsFailedTable' as RegisteredServices
export const bulkSentSmsRejectedTableId = 'bulkSentSmsRejectedTable' as RegisteredServices
export const sentSmsFilterModalId: TmWrappers = 'sentSmsFilterModal'

export type SentSmsFilterModalParams = {
  serviceId: RegisteredServices
}
